import React from 'react';
import Header from '../../../components/header/Header';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

const LicensesContentScreen = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const license = location.state?.license;

    return (
        <>
            <Header title={t('licenses.copyright-information')} redirect={'/profile/licenses'} />
            <div className="content-footer-container scrollable licenses-content">
                {license ? (
                    <>
                        <p style={{ fontWeight: 'bold' }}>{license.name}</p>
                        <p>{`version: ${license.version}`}</p>
                        <p>{`License: ${license.licenses}`}</p>
                        <p style={{ whiteSpace: 'pre-wrap', fontSize: 14, marginTop: 20 }}>{license.licenseText}</p>
                    </>
                ) : (
                    <p>{t('licenses.failed-display-license')}</p>
                )}
            </div>
        </>
    );
};

export default LicensesContentScreen;
